/**
 * Created by linjianxi on 2017/1/12.
 */
/**
 * Created by linjianxi on 2016/11/10.
 */
import * as http from '../../../utils/common'
import * as types from './mutation-type'
import cookie from '../../../utils/cookie'

/**
 * 获取充值列表
 * @param commit
 * @param params
 */
export const payListT = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiActivity/GetPayPageInfo',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        commit(types.PAY_LIST, res.data)
        getOpenId(params)
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 微信支付
 * @param commit
 * @param params
 */
export const wechatPayT = ({commit}, params) => {
  http.post({
    url: '/proxy/trans',
    data: {
      domain: 7,
      api: 2,
      method: 'json',
      param: encodeURIComponent("{'uid': '" + params.data.user_id + "','diamond_id': '" + params.data.diamond_id + "','openid': '" + params._this.openId + "','productType': 'EMlivewap', 'plat': '" + params.data.plat + "'}")
    },
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        // console.log('weixin://wap/pay?appid=' + res.data.appid + '&noncestr=' + res.data.noncestr + '&package=' + 'WAP' + '&prepayid=' + res.data.prepayid + '&sign=' + res.data.sign + '&timestamp=' + res.data.timestamp)
        // window.location.href = 'weixin://wap/pay?appid=' + res.data.appid + '&noncestr=' + res.data.noncestr + '&package=' + 'WAP' + '&prepayid=' + res.data.prepayid + '&sign=' + res.data.sign + '&timestamp=' + res.data.timestamp
        /* wx.config({
         debug: true,
         appId: res.data.appid,
         timestamp: res.data.timestamp,
         nonceStr: res.data.noncestr,
         signature: res.data.sign,
         jsApiList: ['chooseWXPay']
         })
         wx.ready(function () {
         wx.chooseWXPay({
         timestamp: res.data.timestamp,
         nonceStr: res.data.noncestr,
         package: res.data.package,
         signType: 'MD5',
         paySign: res.data.sign,
         success: function (succRes) {
         weiXinCBT(commit, succRes)
         },
         fail: function () {
         }
         })
         })
         wx.error(function (errRes) {
         console.log(errRes)
         }) */
        /* eslint-disable */
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: res.data.appid,
            timeStamp: res.data.timestamp,
            nonceStr: res.data.noncestr,
            package: res.data.package,
            signType: 'MD5',
            paySign: res.data.paysign
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request：ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            }
          }
        )
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 微信：完成支付后回调接口（更新订单状态和返回用户钻石余额）
 * @param commit
 * @param params
 */
export const weiXinCBT = (commit, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/PayCallBackWeixin',
    data: {result_status: params.result_status, result: params.result},
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        commit(types.WECHART_PAY, res.data)
      } else {
        alert(res.message)
      }
    }
  })
}

/**
 * 支付宝支付
 * @param commit
 * @param params
 */
export const aliPayT = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/CreateOrderInfoAliForPC',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        gatewayT(commit, res.data)
        // commit(types.ALIPAY_HTML, {html_form_info: res.data.html_form_info, _this: params._this})
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 调用支付宝接口
 * @param commit
 * @param params
 */
/* eslint-disable */
export const gatewayT = ({commit}, params) => {
  // console.log(params.orderinfo.replace(/"/g,''))
  window.location.href = params.html_form_info
  /*$.ajax({
   type: 'GET',
   url: 'https://mapi.alipay.com/gateway.do?' + params.orderinfo,
   success: function (res) {
   if (res.result === 1) {
   console.log(res)
   alipayCB(commit, res.data)
   } else {
   console.log(res)
   }
   }
   })*/
  /* http.post({
   url: '/LVBpages/api/ApiPay/POSTAliOrderinfo?' + params.orderinfo,
   data: {},
   succ: function (res) {
   if (res.result === 1) {
   console.log(res)
   alipayCB(commit, res.data)
   } else {
   alert(res.message)
   }
   }
   }) */
}
/**
 * 支付宝：完成支付后回调接口（更新订单状态和返回用户钻石余额）
 * @param commit
 * @param params
 */
export const alipayCBT = (commit, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/PayCallBackAli',
    data: {out_trade_no: params.out_trade_no, result_status: '200', result: ''},
    succ: function (res) {
      if (res.result === 1) {
        console.log(res)
      } else {
        alert(res.message)
      }
    }
  })
}

/**
 * 获取用户信息
 * @param commit
 * @param params
 */
export const getUserInfoT = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/GetUserInfo',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        cookie('isUserCookie', true)
        params._this.isUserCookie = true
        // params._this.isSelUse = true
        params._this.selentry = true
        cookie('avatarurl', res.data.avatar_url)
        cookie('nickname', res.data.nickname)
        cookie('emid', res.data.emid)
        cookie('id', res.data.id)
        params._this.avatar_url = res.data.avatar_url
        params._this.nickname = res.data.nickname
        params._this.emid = res.data.emid
        commit(types.USER_INFOR, res.data)
      } else {
        // commit(types.GET_CODE_IMG, '/LVBPages/Api/VerifyCode/GetVerifyCode?reqtype=Server&vcodeTarget=eastmoney')
        // alert(res.message)
        params._this.selentry = false
      }
    }
  })
}

/**
 * 跟新验证码
 * @param commit
 */
/* export const refreshCodeT = ({commit}) => {
 commit(types.GET_CODE_IMG, '/LVBPages/Api/VerifyCode/GetVerifyCode?reqtype=Server&vcodeTarget=eastmoney&time=' + Date.parse(new Date()))
 } */

/**
 * 切换用户
 * @param commit
 */
export const swichUserT = ({commit}, params) => {
  cookie('isUserCookie', false)
  params._this.isUserCookie = false
  commit(types.SWITCH_USER)
}

/**
 * 获取openId
 */
export const getOpenId = (params) => {
  http.post({
    url: '/proxy/trans',
    data: {
      domain: 7,
      api: 3,
      method: 'json',
      param: encodeURIComponent("{'code': '" + params._this.code + "', 'productType': 'EMlivewap'}")
    },
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        params._this.openId = res.data.openid
      } else {
        console.log(res)
      //  params._this.openId = res.data.openid
      //  params._this.$router.push({path: '/water/relay'})
      }
    }
  })
}





// WEBPACK FOOTER //
// ./src/vuex/modules/pay_test/actions.js